import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActionsEventsService } from 'src/app/services/actions-events/actions-events.service';
import { GeneralService } from 'src/app/services/general/general.service';
import { StoreServiceLibrary } from 'src/app/services/store/store.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-start-form',
  templateUrl: './start-form.component.html',
  styleUrls: ['./start-form.component.scss']
})
export class StartFormComponent implements OnInit {
  form: FormGroup;
  companySizes;

  submitted = false;
  showOpenCountry: boolean = false;
  search: string = '';
  countries: any[] = [];

  countrySelect = false;

  countrySelected: any = {
    country: {
      name: "United States",
      img: "./assets/img/backoffice/us-flag.png",
    },
  };

  mailchimpUrl;

  paramsData;

  success = false;
  error = false;
  firstName = '';
  componentHaveAllResources = false;
  private unlisten: () => void;

  constructor(private fb: FormBuilder,
    private _general: GeneralService,
    private elRef: ElementRef,
    private storeService: StoreServiceLibrary,
    private http: HttpClient,
    private events: ActionsEventsService,
    private renderer: Renderer2) { }

  ngOnInit() {
    this.buildForm();
    // this.form.get('country')?.setValue(this.countrySelected?.country || '');

    let universalIsLoad = false;
    universalIsLoad = this._general.stringToBoolean(this.storeService.getIsUniversalLoad() + '');

    if (universalIsLoad && !this.componentHaveAllResources) {
      this.componentHaveAllResources = true;
      this.loadInfoUniversal();
    }

    this.events.universalLoadSubject.subscribe((load) => {
      if (load && !this.componentHaveAllResources) {
        this.componentHaveAllResources = true;
        this.loadInfoUniversal();
      }
    });

    this.events.getCountriesSubject.subscribe((resp) => {
      const countries = this.storeService.getItemFromStorage('COUNTRIES') || false;

      if (countries) {
        this.countries = countries.filter((item) => item?.indicative != 'NULL');
      }
    });

    // Escucha el evento de click en el documento
    this.unlisten = this.renderer.listen('document', 'click', (event: Event) => {
      this.onDocumentClick(event);
    });
  }

  loadInfoUniversal() {
    let objMailChimpConfig = JSON.parse(this.storeService.getJustOneUniversalPropertie('_MAIL_CHIMP_CONFIG') || '{"url":"https://wearenovae.us16.list-manage.com/subscribe/post-json","paramsData":{"u":"99487a4bb698ca677ce56ea35","id":"3333402093","f_id":"00dcbce0f0"}}');
    this.mailchimpUrl = objMailChimpConfig?.url;
    this.paramsData = objMailChimpConfig?.paramsData;

    const countries = this.storeService.getItemFromStorage('COUNTRIES') || false;

    if (countries) {
      this.countries = countries.filter((item) => item?.indicative != 'NULL');
    }

    this.companySizes = JSON.parse(this.storeService.getJustOneUniversalPropertie('_COMPANY_SIZES_FORM') || '["Less than $1 Million","$1–5 Million","$5–10 Million","Over $10 Million"]');
  }

  buildForm() {

    const objAppValidationsForm = this._general.getAppValidationsForm();

    const namesPattern = (objAppValidationsForm?.validations?.names?.pattern);
    const namesMinLength = (Number(objAppValidationsForm?.validations?.names?.minLength));
    const namesMaxLength = (Number(objAppValidationsForm?.validations?.names?.maxLength));

    const lastNamesPattern = (objAppValidationsForm?.validations?.names?.pattern);
    const lastNamesMinLength = (Number(objAppValidationsForm?.validations?.names?.minLength));
    const lastNamesMaxLength = (Number(objAppValidationsForm?.validations?.names?.maxLength));

    const emailPattern = (objAppValidationsForm?.validations?.email?.pattern);

    const jobTitleMinLength = (Number(objAppValidationsForm?.validations?.jobTitle?.minLength));
    const jobTitleMaxLength = (Number(objAppValidationsForm?.validations?.jobTitle?.maxLength));

    const companyMinLength = (Number(objAppValidationsForm?.validations?.company?.minLength));
    const companyMaxLength = (Number(objAppValidationsForm?.validations?.company?.maxLength));

    const companyTypeMinLength = (Number(objAppValidationsForm?.validations?.companyType?.minLength));
    const companyTypeMaxLength = (Number(objAppValidationsForm?.validations?.companyType?.maxLength));

    const messageMaxLength = (Number(objAppValidationsForm?.validations?.message?.maxLength));

    this.form = this.fb.group({
      firstName: [
        '',
        [Validators.required, Validators.minLength(namesMinLength), Validators.maxLength(namesMaxLength), Validators.pattern(namesPattern)],
      ],
      lastName: [
        '',
        [Validators.required, Validators.minLength(lastNamesMinLength), Validators.maxLength(lastNamesMaxLength), Validators.pattern(lastNamesPattern)],
      ],
      email: ['', [Validators.required,
      Validators.email,
      Validators.pattern(emailPattern)]],
      jobTitle: [
        '',
        [Validators.required, Validators.minLength(jobTitleMinLength), Validators.maxLength(jobTitleMaxLength)],
      ],
      company: [
        '',
        [Validators.required, Validators.minLength(companyMinLength), Validators.maxLength(companyMaxLength)],
      ],
      country: ['', Validators.required],
      companyType: [
        '',
        [Validators.required, Validators.minLength(companyTypeMinLength), Validators.maxLength(companyTypeMaxLength)],
      ],
      companySize: [
        '',
        [Validators.required],
      ],
      message: ['', Validators.maxLength(messageMaxLength)],
    });
  }

  submit() {
    this.submitted = true;
   
    if (this.form.invalid) {
      this.submitted = false;
      this.form.markAllAsTouched();
      // Scroll to top so validation errors are visible
      try {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } catch (e) { try { window.scrollTo(0, 0); } catch (err) { } }
      return;
    }

    // console.log('Start form submitted', this.form.value);
    // Reset form after submit
    // this.form.reset();
    this.sendFields();
  }

  getControl(name: string) {
    return this.form.get(name);
  }

  isInvalid(name: string) {
    const control = this.getControl(name);
    return !!(control && control.invalid && (control.touched || control.dirty || this.submitted));
  }

  getError(name: string) {
    const control = this.getControl(name);
    if (!control || !control.errors) {
      return null;
    }

    if (control.errors.required) {
      return 'This field is required';
    }

    if (control.errors.email) {
      return 'Please enter a valid email address';
    }

    if (control.errors.pattern) {
      if (name === 'email') {
        return 'Email format is invalid.';
      }
      if (name === 'firstName' || name === 'lastName') {
        return 'Only letters, spaces, accents, or hyphens are allowed';
      }
      return 'Invalid format';
    }

    if (control.errors.minlength) {
      const required = control.errors.minlength.requiredLength;
      return `Minimum length is ${required} characters.`;
    }

    if (control.errors.maxlength) {
      const required = control.errors.maxlength.requiredLength;
      return `Maximum length is ${required} characters.`;
    }

    return 'Invalid value';
  }

  showOpenCountries(): void {
    if (this.componentHaveAllResources) {
      this.showOpenCountry = !this.showOpenCountry;
    }
  }

  selectCountry(country: any): void {
    this.form.patchValue({ country });
    this.countrySelected.country = country;
    this.showOpenCountry = false;
    this.countrySelect = true;
  }

  onDocumentClick(event: Event) {

    const inputElement = this.elRef.nativeElement.querySelector(
      "#container-countrie"
    );
    if (inputElement && !inputElement.contains(event.target as Node)) {
      // Clic fuera del campo específico, cambia la variable
      this.showOpenCountry = false;
    }
  }


  sendFields() {
    this.success = false;
    this.error = false;

    let params = new HttpParams();

    Object.keys(this.paramsData).forEach(key => {
      params = params.append(key, this.paramsData[key]);
    });

    let formSend = {
      EMAIL: this.form.get('email')?.value,
      FNAME: this.form.get('firstName')?.value,
      LNAME: this.form.get('lastName')?.value,
      JTITLE: this.form.get('jobTitle')?.value,
      COMPANY: this.form.get('company')?.value,
      COUNTRY: this.form.get('country')?.value?.name,
      TCOMPANY: this.form.get('companyType')?.value,
      CSIZE: this.form.get('companySize')?.value,
      INTERESTED: this.form.get('message')?.value || '',
      botField: ''
    };


    this.firstName = this.form.get('firstName')?.value;

    Object.keys(formSend).forEach(key => {
      params = params.append(key, formSend[key]);
    });


    const url = this.mailchimpUrl + '?' + params.toString();

    this.http.jsonp(url, 'c').subscribe({
      next: (res: any) => {
        this.submitted = false;
        if (res.result == 'success') {
          this.form.reset();
          this.success = true;
          // Wait a moment for the view to update, then scroll to top
          setTimeout(() => {
            try {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            } catch (e) {
              try { window.scrollTo(0, 0); } catch (err) { }
            }
          }, 50);
        } else {
          Swal.fire({
            icon: 'error',
            text: 'An unexpected error occurred',
            timer: 2500,
            timerProgressBar: false,
            showConfirmButton: false,
            customClass: {
              popup: 'swal-centered-text'
            }
          });
          this.error = true;
        }
      },
      error: () => {
        this.error = true;
        this.submitted = false;
        Swal.fire({
          icon: 'error',
          text: 'An unexpected error occurred',
          timer: 2500,
          timerProgressBar: false,
          showConfirmButton: false,
          customClass: {
            popup: 'swal-centered-text'
          }
        });
      }
    });
  }

  goBack(): void {
    this.success = false;
    this.submitted = false;
    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      try { window.scrollTo(0, 0); } catch (err) { }
    }
  }

}
